module.exports = __webpack_public_path__ + "img/گوشه-گردو-نرم.f63f8db2.jpg";